// src/components/billing/ContractComponentCard.tsx
import { Badge, Box, Button, Group, Paper, Switch, Text, ThemeIcon } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { ComponentTypeIcon } from "./ComponentTypeIcon";

interface Props {
  type: string;                         // e.g. "RECURRING_SUBSCRIPTION"
  label: string;                        // Mongolian display name
  isPresent: boolean;
  isEnabled?: boolean;
  summary?: React.ReactNode;            // short summary line shown when present
  onAdd?: () => void;
  onEdit?: () => void;
  onToggle?: (enabled: boolean) => void;
}

export function ContractComponentCard({
  type,
  label,
  isPresent,
  isEnabled,
  summary,
  onAdd,
  onEdit,
  onToggle,
}: Props) {
  return (
    <Paper p="md" withBorder radius="md">
      <Group justify="space-between" align="flex-start" wrap="nowrap" gap="md">
        <Group gap="sm" wrap="nowrap" align="flex-start">
          <ThemeIcon variant="light" color={isPresent ? "brand" : "gray"} size={38} radius="md">
            <ComponentTypeIcon type={type} size={18} />
          </ThemeIcon>
          <Box>
            <Group gap="xs">
              <Text fw={600}>{label}</Text>
              {!isPresent && <Badge color="gray" variant="light" size="xs" radius="sm">байхгүй</Badge>}
            </Group>
            {isPresent ? (
              <Box mt={2}>{summary}</Box>
            ) : (
              <Text size="sm" c="dimmed" mt={2}>Тохируулаагүй</Text>
            )}
          </Box>
        </Group>
        <Group gap="sm" wrap="nowrap" align="center">
          {isPresent && (
            onToggle ? (
              <Switch
                checked={!!isEnabled}
                onChange={(e) => onToggle(e.currentTarget.checked)}
                aria-label={`${label} идэвхтэй эсэх`}
              />
            ) : (
              <Badge color={isEnabled === false ? "gray" : "green"} variant="light" radius="sm">
                {isEnabled === false ? "Идэвхгүй" : "Идэвхтэй"}
              </Badge>
            )
          )}
          {isPresent && onEdit && (
            <Button variant="subtle" size="xs" onClick={onEdit}>
              Засах
            </Button>
          )}
          {!isPresent && onAdd && (
            <Button variant="light" color="brand" size="xs" leftSection={<IconPlus size={14} />} onClick={onAdd}>
              Нэмэх
            </Button>
          )}
        </Group>
      </Group>
    </Paper>
  );
}
